import React from 'react';
import { Box } from '@mui/system';

import { makeStyles } from '@mui/styles';
import Typography from '../../atoms/Typography/Typography';

const useStyles = makeStyles({
  mainImage: {
    width: '50vw',
    marginBottom: '20px',
    '@media only screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  titleName: {
    marginLeft: '0',
    fontSize: '24px',
    fontFamily: 'Pretendard',
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: '-0.24px',
    textAlign: 'left',
    color: '#191919',
    '@media only screen and (max-width:768px)': {
      fontSize: '16px',
    },
  },
});

export default function ImageBox(props) {
  const classes = useStyles();
  const { data } = props;
  return (
    <Box>
      {!!data && data !== '' ? (
        <Box>
          <img className={classes.mainImage} src={data.ImageSrc} alt='test' />
          <Typography className={classes.titleName}>{data.ImageName}</Typography>
        </Box>
      ) : (
        <Box>
          <img className={classes.mainImage} src='/images/image/lecture.jpeg' alt='test' />
          <Typography className={classes.titleName}>Lecture</Typography>
        </Box>
      )}
    </Box>
  );
}
